import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {DisplayedAllergenGroup, AllergenGroupRequestDto} from "app/models/menu.model";
import {firstValueFrom} from "rxjs";
import {environment} from "environments/environment";
import {IBaseResponse} from "app/models/baseResponse.model";

@Injectable({
  providedIn: 'root'
})
export class AllergenGroupApiService {
  private requestPath = `${environment.posBaseUrl}/api/front/allergen-group`;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
  ) {}

  async getAllergenGroupsAsync(organizationId: string): Promise<DisplayedAllergenGroup[]> {
    try {
      const response = await firstValueFrom(
        this.http.get<DisplayedAllergenGroup[]>(
          this.requestPath + '/' + organizationId + '/list',
        )
      );
      return response ?? [];
    } catch (exception) {
      console.error('Failed to get allergen groups:', exception);
      throw exception;
    }
  }

  async createAllergenGroupAsync(menuId: string, requestBody: AllergenGroupRequestDto): Promise<DisplayedAllergenGroup> {
    try {
      const response = await firstValueFrom(
        this.http.post<DisplayedAllergenGroup>(
          this.requestPath + '/' + menuId,
          requestBody,
          {
            headers: this.headers,
          }
        )
      );
      return response;
    } catch (exception) {
      console.error('Failed to create allergen group:', exception);
      throw exception;
    }
  }

  async updateAllergenGroupAsync(allergenGroupId: string, requestBody: AllergenGroupRequestDto): Promise<DisplayedAllergenGroup> {
    try {
      const response = await firstValueFrom(
        this.http.put<DisplayedAllergenGroup>(
          this.requestPath + '/' + allergenGroupId,
          requestBody,
          {
            headers: this.headers,
          }
        )
      );
      return response;
    } catch (exception) {
      console.error('Failed to update allergen group:', exception);
      throw exception;
    }
  }

  async delete(allergenGroupId: string): Promise<void> {
    try {
      await firstValueFrom(
        this.http.delete<null>(
          this.requestPath + `/${allergenGroupId}`,
        )
      );
    } catch (exception) {
      console.error('Failed to delete allergen group:', exception);
      throw exception;
    }
  }
}
